import { tokens } from './styles/tokens'

// Klíče objektu zůstávají kvůli ~280 referencím v komponentách.
// Hodnoty čerpají z centrálních tokenů (src/styles/tokens.ts).
// Rozměrové/layoutové hodnoty (table, padding) se nemění.
function buildNewThemeObject() {
  return {
    palette: {
      main: {
        primary: tokens.color.primary[700],
        secondary: tokens.color.neutral[200],
        background: tokens.color.neutral[50],
        sectext: tokens.color.neutral[500],
        highlight: tokens.color.primary[50],
        dark: tokens.color.primary[700],
        gray: tokens.color.neutral[700],
        blackAlpha: 'rgba(23, 26, 30, 0.03)',
        error: tokens.color.error[500],
        bad: tokens.color.error[500],
        lightGray: tokens.color.neutral[400],
        green: tokens.color.success[500],
      },
      // Paleta grafů: brand navy + harmonizované odstíny (8.7.2026).
      graphColors: ['#11457F', '#0E9594', '#5F8FC4', '#D97706', '#7C64A8', '#2A7E19'],
      text: {
        gray: tokens.color.neutral[500],
      },
      background: {
        lightGray: tokens.color.neutral[50],
        gray: tokens.color.neutral[100],
      },
      highlight: {
        bg: 'rgba(51, 105, 159, 0.16)',
        bg2: 'rgba(106, 114, 128, 0.10)',
      },
      orderTiles: {
        main: {
          bg: `linear-gradient(to top, ${tokens.color.primary[600]}, ${tokens.color.primary[400]})`,
          text: tokens.color.white,
        },
        secondary: {
          bg: tokens.color.neutral[200],
          text: tokens.color.neutral[900],
        },
        basic: {
          bg: tokens.color.white,
          text: tokens.color.neutral[900],
        },
      },
      orderTable: {
        searchBar: {
          bg: 'rgba(17, 69, 127, 0.04)',
        },
      },
      // Stavy pokynů: význam zachován, křiklavé odstíny sladěny s paletou.
      state: {
        new: tokens.color.primary[300],
        confirmed: '#12B5BD',
        partiallyFilled: tokens.color.warning[500],
        filled: tokens.color.success[500],
        rejected: tokens.color.error[500],
        expired: tokens.color.neutral[400],
        canceled: tokens.color.neutral[200],
        error: '#F7D5F2',
      },
      // Barvy typů instrumentů nesou datovou identitu — beze změny.
      instrument: {
        EQTY: '#d9a50a',
        FUND: '#d96e0a',
        TypeB: '#6A81BB',
        BOND: '#6A81BB',
        E: '#d9a50a',
        ETF: '#4caf50',
        AAM: '#8AD5FD',
        DERIV: '',
        HYBRID: '',
        MM: '',
        OTHER: '',
      },
      // Paleta uživatelských labelů — uživatelská data, beze změny.
      labels: [
        '#cf2e0a',
        '#ff6d42',
        '#ffc34a',
        '#fff236',
        '#c1f375',
        '#62b861',
        '#127a60',
        '#2284b6',
        '#8cd3ff',
        '#b177e2',
        '#ff9dd8',
        '#a06f3a',
        '#424242',
      ],
    },
    roundness: {
      basic: tokens.radius.lg,
      small: tokens.radius.md,
      left: `${tokens.radius.lg} 0 0 ${tokens.radius.lg}`,
      right: `0 ${tokens.radius.lg} ${tokens.radius.lg} 0`,
    },
    table: {
      tableHead: {
        background: 'transparent',
        margin: '10px 0 0 10px',
        height: '2rem',
        padding: '0',
        borderBottom: 'none',
      },
      tableHeadChildrenText: {
        margin: '0',
        padding: '0',
        fontSize: '0.6875rem',
        fontWeight: 600,
        letterSpacing: '0.05em',
        textTransform: 'uppercase' as const,
        color: tokens.color.neutral[500],
      },
      tableHeadChildren: {
        borderBottom: `1px solid ${tokens.color.neutral[200]}`,
        align: 'left',
        padding: 0,
      },
      tableHeadChildrenFirst: {
        paddingLeft: 20,
        paddingRight: 0,
        borderRadius: 0,
      },
      tableHeadChildrenLast: {
        borderRadius: 0,
      },
      tableContent: {
        fontSize: '30px',
        padding: '25px 0px',
      },
      tableContentIcon: {
        padding: '25px 20px',
        paddingRight: 0,
      },
      tableContentFirst: {
        paddingLeft: 20,
        paddingRight: 0,
      },
      tableContainer: {
        padding: '10px',
        borderRadius: 16,
      },
      tableContentText: {
        fontWeight: '400',
        margin: '0',
        fontSize: '0.7rem',
        textWrap: 'wrap',
      },
      tableBody: {
        margin: '0 70px',
      },
    },
    padding: {
      wrappers: '1rem 0.5rem',
      smallWrapper: '0.5rem',
    },
  }
}

export let newThemeObject = buildNewThemeObject()

// Přepočítá odvozené hodnoty z aktuální barevné palety `tokens` (volá se
// při přepnutí vzhledu, viz contexts/ThemeModeContext.tsx).
export function rebuildNewThemeObject() {
  newThemeObject = buildNewThemeObject()
  return newThemeObject
}
